import { StateContext } from "@ngxs/store";

import { IStateProcessor } from "../state-processor";
import { AppDataStateModel } from "@shared/models/app-data.model";
import { NgxsStoreHelpers } from "@shared/stores/store.helpers";
import { CommonSearchCriteria } from "@shared/models/common-data.model";
import { DefaultCoaching } from "@app/shared/models/coaching.model";

export class CoachingStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return DefaultCoaching.search.searchForm.model.searchCriteria;
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) {
    NgxsStoreHelpers.SetCoachingSearchCriteria(ctx, searchCriteria);
  }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) {
    var currentSearchCriteria = ctx.getState().coaching.search.searchForm.model.searchCriteria;
    this.SetSearchCriteria(ctx, [...newSearchCriteria, ...currentSearchCriteria]);
  }
}
